// DEPENDENCIES
import React, { useState } from 'react';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
// TABS
import ContactUsTab from '../pages/cms/tabs/ContactUsTab';
import ReportIssueTab from '../pages/cms/tabs/ReportIssueTab';
import PublicRecordRequestTab from '../pages/cms/tabs/PublicRecordRequestTab';

const TabbedInterface = () => {
  const [activeTab, setActiveTab] = useState('contact-us');

  const handleTabSelect = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <>
      <CustomBlock
        className="tabs-container"
        id="myTab"
        role="tablist"
      >
        <button
          className={`tab-button ${activeTab === 'contact-us' ? 'active' : 'inactive'} size-mdlg secondary-lighter--clr fw-500`}
          id="contact-us-tab"
          data-bs-toggle="tab"
          data-bs-target="#contact-us-tab-pane"
          type="button"
          role="tab"
          aria-controls="contact-us-tab-pane"
          aria-selected="true"
          onClick={() => handleTabSelect('contact-us')}
        >
          Contact
        </button>
        <button
          className={`tab-button ${activeTab === 'report-issue' ? 'active' : 'inactive'} size-mdlg primary-lighter--clr fw-500`}
          id="report-issue-tab"
          data-bs-toggle="tab"
          data-bs-target="#report-issue-tab-pane"
          type="button"
          role="tab"
          aria-controls="report-issue-tab-pane"
          aria-selected="false"
          onClick={() => handleTabSelect('report-issue')}
        >
          Report
        </button>
        <button
          className={`tab-button ${activeTab === 'records-request' ? 'active' : 'inactive'} size-mdlg secondary-lighter--clr fw-500`}
          id="records-request-tab"
          data-bs-toggle="tab"
          data-bs-target="#records-request-tab-pane"
          type="button"
          role="tab"
          aria-controls="records-request-tab-pane"
          aria-selected="false"
          onClick={() => handleTabSelect('records-request')}
        >
          Records
        </button>
      </CustomBlock>

      {/* CONTENT */}
      <CustomBlock className="tab-content" id="myTabContent">
        {activeTab === 'contact-us' && (
          <CustomBlock
            className="tab-pane fade show active"
            id="contact-us-tab-pane"
            role="tabpanel"
            aria-labelledby="contact-us-tab"
            tabIndex="0"
          >
            <ContactUsTab />
          </CustomBlock>
        )}

        {activeTab === 'report-issue' && (
          <CustomBlock
            className="tab-pane fade show active"
            id="report-issue-tab-pane"
            role="tabpanel"
            aria-labelledby="report-issue-tab"
            tabIndex="0"
          >
            <ReportIssueTab />
          </CustomBlock>
        )}

        {activeTab === 'records-request' && (
          <CustomBlock
            className="tab-pane fade show active"
            id="records-request-tab-pane"
            role="tabpanel"
            aria-labelledby="records-request-tab"
            tabIndex="0"
          >
            <PublicRecordRequestTab />
          </CustomBlock>
        )}
      </CustomBlock>
    </>
  );
};

export default TabbedInterface;